import { DateTime } from 'luxon';
import { getClientAlias } from 'util/client-alias';

export const dateXAxis = (xlabels: string[]) => ({
  scaleType: 'point' as const,
  data: xlabels ?? [],
  valueFormatter: (value: string, { location }: { location: string }) =>
    location === 'tooltip'
      ? DateTime.fromISO(value).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
      : DateTime.fromISO(value).toFormat('MMM dd'),
});

type getFileNameParams = {
  startDate: string;
  endDate: string;
  granularity?: string;
  dataType?: string;
};

export const getFileName = (
  { startDate, endDate, granularity, dataType }: getFileNameParams,
  type:
    | 'OFFER_PERFORMANCE'
    | 'LOCATION_PERFORMANCE'
    | 'OFFER_TRENDS'
    | 'LOCATION_TRENDS',
) => {
  let fileNamePrefix;

  switch (type) {
    case 'OFFER_TRENDS':
      fileNamePrefix = `Incentivio_Loyalty_Offer_Trends_${dataType}_${granularity}`;
      break;
    case 'LOCATION_TRENDS':
      fileNamePrefix = `Incentivio_Location_Loyalty_Trends_${dataType}_${granularity}`;
      break;
    case 'OFFER_PERFORMANCE':
      fileNamePrefix = 'Incentivio_Loyalty_Offer_Performance';
      break;
    case 'LOCATION_PERFORMANCE':
      fileNamePrefix = 'Incentivio_Location_Loyalty_Performance';
      break;
  }

  return `${fileNamePrefix}_${getClientAlias()}_${DateTime.fromISO(
    startDate,
  ).toISODate()}_to_${DateTime.fromISO(endDate).toISODate()}`;
};

// We need to reference these translations somewhere in the code otherwise a pre-commit hook will
// remove them from our translation file. They are all generated dynamically in the code, so we
// need to manually in here.

// t('page.loyaltyPerformanceReport.members.New Sign Ups.label')
// t('page.loyaltyPerformanceReport.members.Active Members.label')
// t('page.loyaltyPerformanceReport.members.Active Members %.label')
// t('page.loyaltyPerformanceReport.members.System Active Members %.label')
// t('page.loyaltyPerformanceReport.newMembers.Organic Sign Ups.label')
// t('page.loyaltyPerformanceReport.newMembers.Referral Sign Ups.label')
// t('page.loyaltyPerformanceReport.sales.Loyalty Contribution Rate %.label')
// t('page.loyaltyPerformanceReport.sales.System Loyalty Contribution Rate %.label')
